export class DatosEstadoNomina {
	public id:number;
	public legajo:string;
	public bloqueado:number;
	public liquidarDesde:string;
	public liquidarHasta:string;
	public ultimaLiquidacion:string;
	public retroactividad:string;
}
